import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import type { Organization } from "../organization";
import { OpportunityReport } from "./";

const createCustomFilter = createCustomFilterForEntity<OpportunityReport>();

export class OpportunityReportFilters {
  /**
   * # 🌟✨ HyperFilter – The Ultimate Filtering Powerhouse!
   * ### 🤝 Filter through complex relations effortlessly
   * ### 📦 Directly filter JSON fields (no backend work required!)
   * ### 🚀 Transforms your filter into a single, optimized DB query
   * ### 🔒 Engineered for maximum SQL injection protection
   *
   * ---
   * ### Example:
   * ```ts
   * myEntityRepo.find({
   *  where: MyEntity.hyperFilter({ ... })
   * })
   * ```
   *
   * ---
   * Built by Natan Salmon
   */
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<OpportunityReport>
  >((filters) => {
    return filterWithRelationsAndJson(OpportunityReport)(filters);
  });

  static isOrganizationReport = createCustomFilter<{
    organization: string | Organization;
  }>(({ organization }) => {
    return this.hyperFilter({
      opportunity: {
        $is: {
          organization: {
            $is: {
              id:
                typeof organization === "string"
                  ? organization
                  : organization.id,
            },
          },
        },
      },
    });
  });
}
